export default __webpack_public_path__ + "static/media/recommend.70ebfeb3.svg";